__turbopack_context__.v({
  "layout1": "ufGKda_layout1",
});
